import numeral from 'numeral';

export function commaFormatted(number) { return numeral(number).format('0,0'); }
export function percentFormatted(number) { return numeral(number).format('0.0%'); }

export function sciFormatted(number) {
  const format = (number > 1000000) ? '0.0a' : '0,0a';
  return numeral(number).format(format);
}



// WEBPACK FOOTER //
// ./src/utils/formatting.js